module.exports = __webpack_public_path__ + "img/NC_xionglei_2019.fddf4fc1.png";